import { AllDayPanel } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  allDayTitleCellComponent: {
    width: '50px !important',
    '&& > :first-of-type': {
      paddingRight: 0,
      height: '100%',
    },
  },
});

export const AllDayTitleCellComponent = (props: AllDayPanel.TitleCellProps) => {
  const { classes } = useStyles();
  return (
    <AllDayPanel.TitleCell
      className={classes.allDayTitleCellComponent}
      {...props}
    ></AllDayPanel.TitleCell>
  );
};
